import * as React from "react";
const SvgIcPlaySolid = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 500 500", fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M75,500l0,-500l430,250z" }));
export default SvgIcPlaySolid;
